import * as React from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { ArrowRightEndOnRectangleIcon } from "@heroicons/react/24/outline";

interface Props {
    onLoginAsClient: () => void;
}

export function ClientRowActionsMenu({ onLoginAsClient }: Props) {
    return (
        <Menu as="div" className="relative inline-block text-left">
            <MenuButton
                aria-label="Meer acties"
                className="flex items-center justify-center rounded-full p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none"
                onClick={(e) => e.stopPropagation()}
            >
                <EllipsisVerticalIcon className="h-5 w-5" />
            </MenuButton>
            <MenuItems
                transition
                anchor={{ to: "bottom end", gap: 4 }}
                className="z-50 w-56 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
            >
                <MenuItem>
                    <button
                        type="button"
                        className="flex w-full items-center gap-2 px-3 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100"
                        onClick={(e) => {
                            e.stopPropagation();
                            onLoginAsClient();
                        }}
                    >
                        <ArrowRightEndOnRectangleIcon className="h-4 w-4 text-gray-400" />
                        Inloggen als klant
                    </button>
                </MenuItem>
            </MenuItems>
        </Menu>
    );
}
